import '../../styles/style.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useEffect, useState } from 'react';
import HeaderBar from './HeaderBar';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useData } from './MemberData';
import { Modal, Backdrop, Fade, Box } from '@mui/material';
import toast, { Toaster } from 'react-hot-toast';
import Cookies from 'js-cookie';
import axios from 'axios';
import React from 'react';

interface ActivityData {
  callsign: number;
  type: string;
  days: string;
  weekly_report: string[];
}

interface Activity {
  monday: string | number | null;
  tuesday: string | number | null;
  wednesday: string | number | null;
  thursday: string | number | null;
  friday: string | number | null;
  saturday: string | number | null;
  sunday: string | number | null;
}

interface Member {
  user_id: number;
  full_name: string;
  callsign: number;
  entry_date: string | Date;
  last_up: string | Date;
  discordID: string;
  functions?: Record<string, boolean | string>;
  certificates?: Record<string, boolean | string>;
  fw: number;
  notes: string;
  grade: string;
  adminLevel: number;
  reintegrated: boolean;
  email: string;
}

const API_URL = 'http://panelpolitie.fplayt.ro:5001';

const refreshAccessToken = async () => {
  try {
    const response = await axios.post(`${API_URL}/api/token`, {
      refreshToken: localStorage.getItem("refreshToken")
    });
    const { accessToken } = response.data;
    localStorage.setItem("token", accessToken);
    return accessToken;
  } catch (error) {
    throw new Error("Unable to refresh token");
  }
};

const makeAuthenticatedRequest = async (url: string, data: any) => {
  try {
    const token = localStorage.getItem("token");
    return await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  } catch (err: any) {
    if (err.response.status === 403 || err.response.data?.error === "Invalid token") {
      try {
        const newToken = await refreshAccessToken();
        return await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${newToken}`
          }
        });
      } catch (refreshError) {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        throw new Error("Session expired. Please log in again.");
      }
    } else {
      throw err;
    }
  }
};

function ActivityPage() {
  const { policeMembersData, getDiscordIDType, penitenciarMembersData, getPoliceMemberInfo, getPenMemberInfo } = useData();
  const [searchTerm, setSearchTerm] = useState('');
  const [activityData, setActivityData] = useState<ActivityData[]>([]);
  const [gestRaport, setGestRaportOpen] = useState(false);
  const [selectedMember, setSelected] = useState("");
  const [manageDutyData, setDutyData] = useState<Activity[]>([]);  
  const [selectedCallsign, setSelectedCallsign] = useState(0);
  const [memberPage, setMemberPage] = useState("PD");
  const [membersToFilter, setMembersToFilter] = useState<Member[]>([]);
  const [selectedType, setSelectedType] = useState("");
  const [activityPage, toggleActivityPage] = useState(false);
  const [concediuModalOpen, setConcediuModalOpen] = useState(false);
  const [myDiscordID, setMyDiscordID] = useState('');
  const [isConducere, setIsConducere] = useState(false);
  const [isHR, setIsHR] = useState(false);

  useEffect(() => {
    const idFromCookies = Cookies.get('myDiscordID') || '';
    setMyDiscordID(idFromCookies);
  }, []);

  useEffect(() => {
    let isConducereTemp = false;
    let isHRTemp = false;
    if (myDiscordID) {
      getActivityData();
      setMembersToFilter(policeMembersData);
      for (let index = 0; index < policeMembersData.length; index++) {
        const element = policeMembersData[index];
        if (element.discordID === myDiscordID && (element.grade === "SUB-COMISAR" || element.grade === "COMISAR" || element.grade === "COMISAR-SEF" || element.grade === "CHESTOR-GENERAL")) {
          isConducereTemp = true;
        }
        if (element.discordID === myDiscordID && (element.functions?.['resurse umane'] === true || typeof element.functions?.['resurse umane'] === "string")) {
          isHRTemp = true;
        }
      }
      setIsHR(isHRTemp);
      setIsConducere(isConducereTemp);
    }
  }, [myDiscordID, policeMembersData]);

  const filteredMembers = membersToFilter
  .filter((member) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      member.full_name.toLowerCase().includes(searchLower) ||
      String(member.callsign).padStart(3, '0').includes(searchLower) ||
      String(member.user_id).includes(searchLower)
    );
  })
  .sort((a, b) => a.callsign - b.callsign); 

  async function getActivityData() {
    try {
      const response = await axios.get(`${API_URL}/activity/get`)
  
      if (response && response.data) {
        setActivityData(response.data);
      } else {
        setActivityData([]);
      }
    } catch (err) {
      console.error('Unexpected error:', err);
      setActivityData([]);
    }
  }

  const style2 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    height: '40%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: '#191919',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 4,
  };

  const openChangeModal = async (callsign: number, type: string) => {
    setSelected(`[${type === "pol" ? String(callsign).padStart(3, '0') : `P-${String(callsign).padStart(2, '0')}`}] ${type === "pol" ? getPoliceMemberInfo(callsign, "full_name") : getPenMemberInfo(callsign, "full_name")}`);
    setSelectedType(type);
    try {
      const response = await axios.get(`${API_URL}/api/activityByCS?callsign=${callsign}&type=${type}`);
      if (response && response.data) {
        const day = JSON.parse(response.data[0].days)
        const dutyData = [{
          monday: day[0] || null,
          tuesday: day[1] || null,
          wednesday: day[2] || null,
          thursday: day[3] || null,
          friday: day[4] || null,
          saturday: day[5] || null,
          sunday: day[6] || null,
        }];
        setSelectedCallsign(callsign);
        setDutyData(dutyData);
        setGestRaportOpen(true);
      }
    } catch (error) {
      console.log(error);
      toast.error("A apărut o eroare! Nu s-a putut deschide meniul.");
      return;
    }
  
  };
  
  const handleGestRaportClose = () => {
    setGestRaportOpen(false);
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, day: keyof Activity) => {
    const value = e.target.value;
  
    setDutyData((prevData) => {
      const updatedData = [...prevData];
      if (updatedData[0]) {
        updatedData[0][day] = value;
      }
      return updatedData;
    });
  };

  const saveDutyData = async () => {
    try {
      const response = await makeAuthenticatedRequest(`${API_URL}/activity/updateActivity`, {
        callsign: selectedCallsign,
        days: [manageDutyData[0].monday,
          manageDutyData[0].tuesday,
          manageDutyData[0].wednesday,
          manageDutyData[0].thursday,
          manageDutyData[0].friday,
          manageDutyData[0].saturday,
          manageDutyData[0].sunday],
        type: selectedType,
        discordID: myDiscordID
      })
      if (response.statusText === "OK") {
        handleGestRaportClose();
        getActivityData();
        toast.success("Modificările au fost salvate!");
      } else {
        toast.error("A apărut o eroare! Modificările nu au fost salvate.");
        return;
      }
    } catch (err: any) {
      if (err.response.data.error === "Invalid token") {
        toast.error("Token invalid! Te rugăm să te reconectezi.");
        localStorage.removeItem("token");
      } else {
        toast.error("A apărut o eroare! Modificările nu au fost salvate.");
      }
    }
  }

  const handleSetMemberPage = (type: string) => {
    if (type === "PD") {
      setMembersToFilter(policeMembersData)
      setMemberPage("PD");
    } else {
      setMembersToFilter(penitenciarMembersData)
      setMemberPage("PEN");
    }
  }

  const [concediuType, setConcediuType] = useState("");
  const [concediuCallsign, setConcediuCallsign] = useState("");
  const [daysConcediu, setDaysConcediu] = useState("");

  const concediuStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height: '45%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: '#191919',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 4,
  };

  const openAprobareConcediuModal = () => {
    setConcediuModalOpen(true);
  }

  const giveAprobareConcediu = async () => {
    if (!concediuType || !concediuCallsign || !daysConcediu) {
      toast.error("Te rog completează toate câmpurile!");
      return;
    }
    try {
      await makeAuthenticatedRequest(`${API_URL}/activity/giveConcediu`, {
        callsign: concediuCallsign,
        type: concediuType,
        discordID: concediuType === "pol" ? getPoliceMemberInfo(Number(concediuCallsign), "discordID") : getPenMemberInfo(Number(concediuCallsign), "discordID"),
        days: daysConcediu,
        myDiscordID: myDiscordID
      })
      toast.success("Concediul a fost aprobat!");
      handleConcediuModalClose();
    } catch (err: any) {
      if (err.response.data.error === "Invalid token") {
        toast.error("Token invalid! Te rugăm să te reconectezi.");
        localStorage.removeItem("token");
      } else {
        toast.error("A apărut o eroare! Modificările nu au fost salvate.");
      }
    }
  }

  const handleConcediuModalClose = () => {
    setConcediuType("");
    setConcediuCallsign("");
    setDaysConcediu("");
    setConcediuModalOpen(false);
  }

  function evaluateDutyData(actData: (string | null)[]): string | number {
    const isNumeric = (val: string | null | undefined): boolean =>
      typeof val === "string" && !isNaN(Number(val)) && val.trim() !== "";

    const parsedNumbers = actData
      .filter(isNumeric)
      .map(val => Number(val))
      .filter(val => val >= 0); 

    const countCO = actData.filter(val => val === "CO").length;
    const countSlash = actData.filter(val => val === "-").length;

    const totalSpecial = countCO + countSlash;

    if (totalSpecial === 7) return "CO";

    if (parsedNumbers.length < 3) {
      const avg = parsedNumbers.reduce((sum, val) => sum + val, 0) / (parsedNumbers.length || 1);

      if (avg < 120) {
        return Math.round(avg);
      } else {
        return totalSpecial < 5 ? `${Math.round(avg)}/CO` : "CO";
      }
    }

    const finalAvg = parsedNumbers.reduce((sum, val) => sum + val, 0) / parsedNumbers.length;
    return Math.round(finalAvg);
  }

  function getLastFourFilled(arr: (string | number)[]) {
    const filled = arr.filter(item => item !== "" && item !== null && item !== undefined);
    const lastFour = filled.slice(-4);
    while (lastFour.length < 4) {
      lastFour.unshift(0);
    }
    return lastFour;
  }

  return (
    <div className="w-full h-full flex flex-col">
      <HeaderBar currentPage="Evidență Activitate" />
      <div className="w-[99%] h-[87%] box-border p-[1%] pt-[0.5%] bg-[#605D5D61] flex flex-col gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
        <div className="w-full h-[7%] flex items-center justify-between">
          <div className="w-[30%] h-full flex items-center justify-between">
              <span className="textSemiBold text-[1.1vw]  text-[#ffffff]">Membrii Departament</span>
              {memberPage === "PD" ? (
                <div onClick={() => handleSetMemberPage("PEN")} className="w-[50%] h-[80%] flex items-center justify-center bg-gradient-to-r from-[#319BC1] to-[#193989] rounded-[0.5vw] shadow-xl cursor-pointer">
                  <span className="textSemiBold text-white text-[0.9vw]">Membrii Penitenciar</span>
                </div>
              ) : (
                <div onClick={() => handleSetMemberPage("PD")} className="w-[50%] h-[80%] flex items-center justify-center bg-gradient-to-r from-[#319BC1] to-[#193989] rounded-[0.5vw] shadow-xl cursor-pointer">
                  <span className="textSemiBold text-white text-[0.9vw]">Membrii Poliție</span>
                </div>
              )}
            </div>          
            <div className="w-[60%] h-full flex items-center justify-center gap-[1%]">
              <div onClick={() => toggleActivityPage(!activityPage)} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                <span className="textBold text-white text-[.8vw]">RAPORT ACTIVITATE</span>
              </div>
              <div onClick={() => openAprobareConcediuModal()} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                <span className="textBold text-white text-[.8vw]">APROBARE CONCEDIU</span>
              </div>
            </div>
          <div className=" bg-[#ffffff10] border  border-[#ffffff20] w-[15%] h-[90%] rounded-full flex items-center justify-between box-border px-[1%]">
            <input
              type="text"
              placeholder="Caută un polițist"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pb-[1%]   text-[#ffffff50] placeholder-[#ffffff50] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent h-full border-none outline-none"
            />
            <FontAwesomeIcon className="  text-[#ffffff50] text-[0.8vw]" icon={faMagnifyingGlass} />
          </div>
        </div>
        <div className=" bg-[#323232] w-full h-[93%] rounded-xl flex flex-col overflow-y-scroll">
          {activityPage === false ? (
            <>
              <div className="w-full min-h-[7%] flex items-center gap-[0.9vw] box-border pl-[1%] pr-[1%] border-b-[3px] border-[#525252]">
                <span className="textBold text-center text-white text-[1vw] w-[3%]">
                  ID
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[3.5%]">
                  CS
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[10.9%]">
                  NUME
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[10%]">
                  GRAD
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[36.7%]">
                  MINTUE PONTAJ PER ZI
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[4%]">
                  TOTAL
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[4%]">
                  MEDIE
                </span>
                {(isHR || isConducere) && (
                  <>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                    <span className="textBold text-center text-white text-[1vw] w-[4%]">
                      GESTIONEAZĂ
                    </span>
                  </>
                )}
              </div>
              {filteredMembers.map((memberData, index) => {
                const activity = activityData.find((m) => m.callsign === memberData.callsign);
                let actData = Array(7).fill(0);
                if (activity) {
                  actData = JSON.parse(activity.days);
                }
                return (
                  <div key={index} className="w-full min-h-[7%] flex items-center gap-[1%] box-border pl-[1%] pr-[1%] border-b-[1px] border-[#D0D0D0]">
                    <span className="textSemiBold w-[3%] text-center text-[0.8vw] text-[#ffffff]">{memberData.user_id}</span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    <span className={`textSemiBold w-[3.5%] text-center text-[0.8vw] ${
                      memberData.adminLevel === 1
                        ? "text-[#ffffff80]"
                        : memberData.adminLevel === 2
                        ? "text-green-500"
                        : memberData.adminLevel === 3
                        ? "text-blue-500"
                        : memberData.adminLevel === 4
                        ? "text-yellow-300"
                        : memberData.adminLevel === 5
                        ? "text-orange-500"
                        : memberData.adminLevel === 6
                        ? "text-red-500"
                        : "text-[#ffffff]"
                    }`}>
                      {getDiscordIDType(memberData.discordID) === "pen"
                        ? `P-${String(memberData.callsign).padStart(2, "0")}`
                        : String(memberData.callsign).padStart(3, "0")}
                    </span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    <span className="textSemiBold w-[11%] text-center text-[0.8vw] text-[#ffffff]">{memberData.full_name}</span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    <span className="textSemiBold w-[10%] text-center text-[0.8vw] text-[#ffffff]">{memberData.grade}</span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    <span className="textSemiBold w-[3.5%] text-center text-[0.8vw] text-[#ffffff]">Lu: {actData[0]}</span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    <span className="textSemiBold w-[3.5%] text-center text-[0.8vw] text-[#ffffff]">Ma: {actData[1]}</span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    <span className="textSemiBold w-[3.5%] text-center text-[0.8vw] text-[#ffffff]">Mi: {actData[2]}</span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    <span className="textSemiBold w-[3.5%] text-center text-[0.8vw] text-[#ffffff]">Jo: {actData[3]}</span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    <span className="textSemiBold w-[3.5%] text-center text-[0.8vw] text-[#ffffff]">Vi: {actData[4]}</span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    <span className="textSemiBold w-[3.5%] text-center text-[0.8vw] text-[#ffffff]">Sâ: {actData[5]}</span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    <span className="textSemiBold w-[3.5%] text-center text-[0.8vw] text-[#ffffff]">Du: {actData[6]}</span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    <span className="textSemiBold w-[4%] text-center text-[0.8vw] text-[#ffffff]">
                      {
                        actData
                          .map(val => Number(val))
                          .filter(num => !isNaN(num))
                          .reduce((acc, num) => acc + num, 0)
                      }
                    </span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    {(() => {
                      const evaluation = evaluateDutyData(actData);
                      const getColorClass = (value: string | number): string => {
                        if (value === "CO") return "text-blue-500";
                        if (typeof value === "string" && value.endsWith("/CO")) {
                          const numberPart = parseInt(value);
                          if (numberPart >= 120) return "text-green-500";
                          if (numberPart >= 60) return "text-yellow-500";
                          return "text-red-500";
                        }
                        if (typeof value === "number") {
                          if (value >= 120) return "text-green-500";
                          if (value >= 60) return "text-yellow-500";
                          return "text-red-500";
                        }
                        return "text-white";
                      };

                      return (
                        <span className={`textSemiBold w-[4%] text-center text-[0.8vw] ${getColorClass(evaluation)}`}>
                          {evaluation}
                        </span>
                      );
                    })()}
                    {(isHR || isConducere) && (
                      <>
                        <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                        <div onClick={() => openChangeModal(memberData.callsign, (memberData.grade === "AGENT-PAZA" || memberData.grade === "AGENT-PAZA-SEF" || memberData.grade === "DIRECTOR-PENITENCIAR" ? "pen" : "pol"))} className="w-[7%] h-[70%] px-[1%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                          <span className="textBold text-white text-[.8vw]">GESTIONEAZĂ</span>
                        </div>
                      </>
                    )}
                  </div>
                )
              })}
            </>
          ) : (
            <>
              <div className="w-full min-h-[7%] flex items-center gap-[0.9vw] box-border pl-[1%] pr-[1%] border-b-[3px] border-[#525252]">
                <span className="textBold text-center text-white text-[1vw] w-[3%]">
                  ID
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[3.5%]">
                  CS
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[10.9%]">
                  NUME
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[10%]">
                  GRAD
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[9.9%]">
                  ACUM 4 SAPT.
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[10%]">
                  ACUM 3 SAPT.
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[10%]">
                  ACUM 2 SAPT.
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[9.9%]">
                  ACUM 1 SAPT.
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              </div>
              {filteredMembers.map((memberData, index) => {
                const activity = activityData.find(
                  (m) => m.callsign === memberData.callsign && m.type === getDiscordIDType(memberData.discordID)
                );
                let actData: any[] = [];
                if (activity) {
                  if (typeof activity.weekly_report === 'string') {
                    try {
                      actData = JSON.parse(activity.weekly_report);
                    } catch (e) {
                      actData = ["", "", "", ""];
                    }
                  } else if (Array.isArray(activity.weekly_report)) {
                    actData = activity.weekly_report;
                  } else {
                    actData = ["", "", "", ""];
                  }
                }

                return (
                  <div
                    key={index}
                    className="w-full min-h-[7%] flex items-center gap-[1%] box-border pl-[1%] pr-[1%] border-b-[1px] border-[#D0D0D0]"
                  >
                    <span className="textSemiBold w-[3%] text-center text-[0.8vw] text-[#ffffff]">
                      {memberData.user_id}
                    </span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    <span
                      className={`textSemiBold w-[3.5%] text-center text-[0.8vw] ${
                        memberData.adminLevel === 1
                          ? "text-[#ffffff80]"
                          : memberData.adminLevel === 2
                          ? "text-green-500"
                          : memberData.adminLevel === 3
                          ? "text-blue-500"
                          : memberData.adminLevel === 4
                          ? "text-yellow-300"
                          : memberData.adminLevel === 5
                          ? "text-orange-500"
                          : memberData.adminLevel === 6
                          ? "text-red-500"
                          : "text-[#ffffff]"
                      }`}
                    >
                      {getDiscordIDType(memberData.discordID) === "pen"
                        ? `P-${String(memberData.callsign).padStart(2, "0")}`
                        : String(memberData.callsign).padStart(3, "0")}
                    </span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    <span className="textSemiBold w-[11%] text-center text-[0.8vw] text-[#ffffff]">
                      {memberData.full_name}
                    </span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    <span className="textSemiBold w-[10%] text-center text-[0.8vw] text-[#ffffff]">
                      {memberData.grade}
                    </span>
                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                    {getLastFourFilled(actData).map((data: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined, i: React.Key | null | undefined) => (
                      <React.Fragment key={i}>
                        <span className="textSemiBold w-[10%] text-center text-[0.8vw] text-[#ffffff]">
                          {data}
                        </span>
                        <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                      </React.Fragment>
                    ))}
                  </div>
                );
              })}

            </>
          )}
        </div>
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={gestRaport}
        onClose={handleGestRaportClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={gestRaport}>
          <Box sx={style2} className="flex flex-col">
            <span className=" text-white textSemiBold text-[1vw] w-full text-center">Gestionează activitate - {selectedMember}</span>
            <div className="w-full h-full  bg-[#282828] box-border rounded-[0.5vw] flex items-center justify-between">
              <div className="w-[49%] h-full flex flex-col justify-center gap-[2%] box-border pl-[2%]">
                <div className="w-full h-[10%] flex items-center gap-[2%]">
                  <span className="textBold  text-white text-[.9vw]">Luni: </span>
                  <input value={manageDutyData[0]?.monday || ''} onChange={(e) => handleInputChange(e, 'monday')} type="text" placeholder="Introdu valoare" className="outline-none border-b-[1px] border-[#393939] focus:border-[#D8630F]  text-white textMedium text-[.9vw] bg-transparent w-[40%]" />
                </div>
                <div className="w-full h-[10%] flex items-center gap-[2%]">
                  <span className="textBold  text-white text-[.9vw]">Marți: </span>
                  <input value={manageDutyData[0]?.tuesday || ''} onChange={(e) => handleInputChange(e, 'tuesday')} type="text" placeholder="Introdu valoare" className="outline-none border-b-[1px] border-[#393939] focus:border-[#D8630F]  text-white textMedium text-[.9vw] bg-transparent w-[40%]" />
                </div>
                <div className="w-full h-[10%] flex items-center gap-[2%]">
                  <span className="textBold  text-white text-[.9vw]">Miercuri: </span>
                  <input value={manageDutyData[0]?.wednesday || ''} onChange={(e) => handleInputChange(e, 'wednesday')} type="text" placeholder="Introdu valoare" className="outline-none border-b-[1px] border-[#393939] focus:border-[#D8630F]  text-white textMedium text-[.9vw] bg-transparent w-[40%]" />
                </div>
                <div className="w-full h-[10%] flex items-center gap-[2%]">
                  <span className="textBold  text-white text-[.9vw]">Joi: </span>
                  <input value={manageDutyData[0]?.thursday || ''} onChange={(e) => handleInputChange(e, 'thursday')} type="text" placeholder="Introdu valoare" className="outline-none border-b-[1px] border-[#393939] focus:border-[#D8630F]  text-white textMedium text-[.9vw] bg-transparent w-[40%]" />
                </div>
                <div className="w-full h-[10%] flex items-center gap-[2%]">
                  <span className="textBold  text-white text-[.9vw]">Vineri: </span>
                  <input value={manageDutyData[0]?.friday || ''} onChange={(e) => handleInputChange(e, 'friday')} type="text" placeholder="Introdu valoare" className="outline-none border-b-[1px] border-[#393939] focus:border-[#D8630F]  text-white textMedium text-[.9vw] bg-transparent w-[40%]" />
                </div>
                <div className="w-full h-[10%] flex items-center gap-[2%]">
                  <span className="textBold  text-white text-[.9vw]">Sâmbătă: </span>
                  <input value={manageDutyData[0]?.saturday || ''} onChange={(e) => handleInputChange(e, 'saturday')} type="text" placeholder="Introdu valoare" className="outline-none border-b-[1px] border-[#393939] focus:border-[#D8630F]  text-white textMedium text-[.9vw] bg-transparent w-[40%]" />
                </div>
                <div className="w-full h-[10%] flex items-center gap-[2%]">
                  <span className="textBold  text-white text-[.9vw]">Duminică: </span>
                  <input value={manageDutyData[0]?.sunday || ''} onChange={(e) => handleInputChange(e, 'sunday')} type="text" placeholder="Introdu valoare" className="outline-none border-b-[1px] border-[#393939] focus:border-[#D8630F]  text-white textMedium text-[.9vw] bg-transparent w-[40%]" />
                </div>
              </div>
              <div className="w-[1px] h-[90%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
              <div className="w-[49%] h-full flex items-center justify-center">
                <div onClick={saveDutyData} className="py-[3%] px-[5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[1.1vw]">SALVEAZĂ ACTIVITATE</span>
                </div>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={concediuModalOpen}
        onClose={handleConcediuModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={concediuModalOpen}>
          <Box sx={concediuStyle} className="flex flex-col">
            <span className="text-white textSemiBold text-[1vw] w-full text-center">APROBARE CONCEDIU POLIȚIE/PENITENCIAR</span>
            <div className="w-[100%] h-full rounded-[0.5vw] flex flex-col items-center gap-[0.5%] overflow-y-scroll">
              <input
                onChange={e => setConcediuType(e.target.value)}
                placeholder="Introdu tip (pol / pen)"
                type="text"
                className="w-[80%] h-[17%] mt-[5%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
              />
              <input
                onChange={e => setConcediuCallsign(e.target.value)}
                placeholder="Introdu Callsign"
                type="text"
                className="w-[80%] h-[17%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
              />
              <input
                onChange={e => setDaysConcediu(e.target.value)}
                placeholder="Introdu zile aprobare"
                type="text"
                className="w-[80%] h-[17%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
              />
              <div onClick={() => giveAprobareConcediu()} className="cursor-pointer mt-[10%] w-[80%] h-[20%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
                <span className="text-white textBold text-[1.1vw]">OFERĂ APROBARE</span>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
      <Toaster
        position="top-right"
        reverseOrder={false}
      />
    </div>
  );
}

export default ActivityPage;